<template>
  <div class="phases__phase phase3">
    <div class="phases__phase__header">
      <div class="color-label">
        <div
          class="circle circle-color-label"
          :style="{ backgroundColor: getRiskColor(color1) }"
        ></div>
        <div
          v-if="color2"
          class="circle circle-color-label"
          :style="{ backgroundColor: getRiskColor(color2) }"
        ></div>
      </div>
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="action">
        <slot name="step-link" class="link"></slot>
        <!-- <div class="btn btn-success">Ver</div> -->
      </div>
    </div>
    <div class="phases__phase__body">
      <div class="description">
        <div class="description__title">
          <slot name="description"></slot>
          <label>
            <b>SITUAÇÕES:</b> {{ phaseData.total }}
          </label>
        </div>
      </div>
      <div class="status">
        <div class="status__title mb-3"><b>STATUS ATUAL</b></div>
        <div class="status__table">
          <table class="status__table__table table-striped">
            <tbody>
              <tr>
                <td>DELEGADO</td>
                <td>{{ phaseData.delegated || 0 }}</td>
                <td>{{ phaseData.delegatedPercentage.toFixed(2) || 0 }} %</td>
              </tr>
              <tr>
                <td>PROGRAMADO</td>
                <td>{{ phaseData.scheduled || 0 }}</td>
                <td>{{ phaseData.scheduledPercentage.toFixed(2) || 0 }} %</td>
              </tr>
              <tr>
                <td>ORÇADO</td>
                <td>{{ phaseData.budgted || 0 }}</td>
                <td>{{ phaseData.budgtedPercentage.toFixed(2) || 0 }} %</td>
              </tr>
              <tr>
                <td>PROJETADO</td>
                <td>{{ phaseData.projected || 0 }}</td>
                <td>{{ phaseData.projectedPercentage.toFixed(2) || 0 }} %</td>
              </tr>
              <tr>
                <td>EM ADEQUAÇÃO</td>
                <td>{{ phaseData.inAdequacy || 0 }}</td>
                <td>{{ phaseData.inAdequacyPercentage.toFixed(2) || 0 }} %</td>
              </tr>
              <tr>
                <td>CONCLUÍDO</td>
                <td>{{ phaseData.concluded || 0 }}</td>
                <td>{{ phaseData.concludedPercentage.toFixed(2) || 0 }} %</td>
              </tr>
              <tr>
                <td>HOMOLOGADO</td>
                <td>{{ phaseData.homologated || 0 }}</td>
                <td>{{ phaseData.homologatedPercentage.toFixed(2) || 0 }} %</td>
              </tr>
            </tbody>
            <!-- <tfoot v-if="showFooter">
              <tr>
                <td colspan="3">Total previsto em penalidade = R$ {{ '-' }}</td>
              </tr>
            </tfoot> -->
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import useDegreeOfRisk from '@/modules/DegreeOfRiskUtil.js'

  export default {
    setup() {
      const { getRiskColor } = useDegreeOfRisk()

      return {
        getRiskColor,
      }
    },
    props: {
      showFooter: {
        type: Boolean,
        required: false,
        default: false,
      },
      color1: {
        type: Number,
        required: true,
      },
      color2: {
        type: Number,
        required: false,
      },
      phaseData: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
  }
</script>

<style lang="scss" scoped>
  .phases__phase {
    border-radius: 25px;
    width: 33%;
    min-width: 280px;

    border: 2px solid #383838;

    display: flex;
    flex-direction: column;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-top-left-radius: 20px;
      border-top-right-radius: 20px;

      padding: 15px 20px;

      background-color: #383838;
      color: #fff;

      font-size: 1.2rem;
    }

    &__body {
      padding-top: 5px;

      flex: 1;
      display: flex;
      flex-direction: column;

      .description {
        padding: 0 5px;
        font-size: 0.9rem;
      }

      .status {
        margin-top: 10px;

        flex: 1;
        display: flex;
        flex-direction: column;

        .status__title {
          text-align: center;
        }

        .status__total {
          font-size: 0.8rem;
          padding: 0 5px;
        }

        .status__table {
          font-size: 0.7rem;

          height: 100%;

          &__table {
            width: 100%;
            border-bottom-left-radius: 25px;
            border-bottom-right-radius: 25px;
            overflow: hidden;
            height: 100%;

            tfoot {
              text-align: center;
            }

            tr td {
              padding: 5px 10px !important;
            }
          }
        }
      }
    }
  }

  .color-label {
    display: flex;
    align-items: center;
    justify-content: center;

    .circle {
      border-radius: 50%;
    }

    .circle-color-label {
      width: 20px;
      height: 20px;

      background-color: green;

      &:not(:first-child) {
        margin-left: 5px;
      }
    }
  }
</style>
